<template>

    <AjanlatBase :titleExtra="titleExtra" v-if="supershopVisible()">

        <v-form slot="biztositoi-adatok" ref="ajanlat-adatok">

            <v-layout row wrap>

                <BnFormField v-if="supershopVisible()" :attributes="supershop"/>

            </v-layout>

        </v-form>

    </AjanlatBase>

</template>

<script>
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import AjanlatBase from '../KGFBAjanlatBase.vue';
import offerData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/OfferData';

export default {
    name: 'AjanlatAdatokB11_V0',
    components: {
        BnFormField,
        AjanlatBase,
    },
    mixins: [offerData],
    methods: {
        supershopVisible() {
            // return this.kedvezmenyek?.supershop === true;
            return +this.$store.getters.tarifaData.ajanl_kock_kezd < 20250601;
        },
    },
    version: 'v0',
    data() {
        return {
            supershop: {
                type: 'text',
                label: 'SuperShop kártyaszám',
                visible: true,
                editable: true,
                help: true,
                mezo: 'supershop',
                path: 'tarifaData.supershop',
                mask: '################',
            },
        };
    },
};
</script>
